import PatientObjectBaseProvider from "./patientObjectBaseProvider";

export default class SchoolDataProvider extends PatientObjectBaseProvider {
	constructor($http, patientProvider, storage, eventBus) {
		super("schoolDataCurrent", $http, patientProvider, storage, eventBus);
	}
}
